<template>
  <div class=" w-screen h-screen flex bg">
    <div class="dark:bg-gray-900 transition-colors duration-300 bg-gray-50 m-auto w-3/4 xl:w-1/2 h-1/2 rounded-md shadow-lg py-8 overflow-y-scroll lg:overflow-y-hidden">
        <h1 class="text-center text-gray-700 dark:text-indigo-400 text-3xl">Redefinir uma nova senha</h1>
        <form novalidate @submit.prevent="sendPassword()" class="mx-auto grid grid-cols-2 gap-x-2 gap-y-4 pt-8 w-full md:w-3/5" >
            <p class="col-span-2 text-gray-800 dark:text-gray-500">Insira nos campos abaixo uma nova senha</p>
            <span class="col-span-2">
                <Input label="Senha" type="password" v-model="state.password.password" :validation="v$.password.password"/>
            </span>
            <span class="col-span-2">
                <Input label="Confirmação" type="password" v-model="state.password.confirm" :validation="v$.password.confirm"/>
            </span>
            <button type="submit" class="btn col-span-2 bg-indigo-700 h-10 rounded-md uppercase text-gray-50 flex items-center justify-center" :disabled="v$.$invalid || loading">
                <span v-if="loading" class="ml-2 w-5 h-5"> 
                    <Spinner width="4"/>
                </span>
                <span v-else>Redefinir</span>
            </button>
        </form>
    </div>
  </div>
</template>

<script>
import Input from '@/components/Design/Input'
import { reactive, ref } from '@vue/reactivity'
import { computed, onMounted } from '@vue/runtime-core'
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'
import { passwordRegistration } from '@/mixins/validators.js'
import { useRoute } from 'vue-router'
import { displayNotification } from '../mixins/notification'
import { POST_MUDAR_SENHA } from '../mixins/api'
import axios from 'axios'

export default {
    name: 'Auth',
    components: {
      Input
    },
    setup() {
        const state = reactive({
            password: {
                password: '',
                confirm: ''
            }
        })

        const loading = ref(false)

        const route = useRoute()

        const token = ref('')

        const rules = computed(() => {
            return {
                password: {
                    password : passwordRegistration(),
                    confirm: {
                        required:
                            helpers.withMessage('Este campo é obrigatório', required),
                        sameAs:
                            helpers.withMessage('As senhas devem ser iguais', (value) =>  value === state.password.password )
                    }
                },
            }
        })
        const v$ = useVuelidate(rules, state)

        onMounted(async () => {
            await axios.get('/sanctum/csrf-cookie')
            token.value = route.query.token
            
        })

        const sendPassword =(async () => {
            const body = {
                token: token.value,
                password: state.password.password,
                confirmPassword: state.password.confirm
            }
            await POST_MUDAR_SENHA(body).then(r => {
                displayNotification(r)
            }).catch(e => {
                displayNotification(e.response)
            })
        })

        return {
            loading,
            sendPassword,
            confirm,
            v$,
            state,
        }
    }
}
</script>

<style scoped>
.fade-enter-from {
  opacity: 0;
  transform: translateY(-10%);
}
.fade-enter-to {
  opacity: 1;
  transform: translateY(0%);
}

.fade-enter-active {
  transition: all 0.5s ease-in-out;
  transition-delay: 0.5s;
}

.fade-leave-active {
  transition: all 0.5s ease-in-out;
}

.fade-leave-from {
  opacity: 1;
  transform: translateY(0%);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(10%);
}

.bg {
background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1844%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='url(%23SvgjsLinearGradient1845)'%3e%3c/rect%3e%3cpath d='M1440 0L1122.33 0L1440 58.89z' fill='rgba(255%2c 255%2c 255%2c .1)'%3e%3c/path%3e%3cpath d='M1122.33 0L1440 58.89L1440 97.5L659.2099999999999 0z' fill='rgba(255%2c 255%2c 255%2c .075)'%3e%3c/path%3e%3cpath d='M659.21 0L1440 97.5L1440 293.12L393.01000000000005 0z' fill='rgba(255%2c 255%2c 255%2c .05)'%3e%3c/path%3e%3cpath d='M393.01 0L1440 293.12L1440 357.85L128.21999999999997 0z' fill='rgba(255%2c 255%2c 255%2c .025)'%3e%3c/path%3e%3cpath d='M0 560L10.79 560L0 553.57z' fill='rgba(0%2c 0%2c 0%2c .1)'%3e%3c/path%3e%3cpath d='M0 553.57L10.79 560L744.2099999999999 560L0 322.96000000000004z' fill='rgba(0%2c 0%2c 0%2c .075)'%3e%3c/path%3e%3cpath d='M0 322.96L744.2099999999999 560L1060.12 560L0 230.42999999999998z' fill='rgba(0%2c 0%2c 0%2c .05)'%3e%3c/path%3e%3cpath d='M0 230.42999999999995L1060.12 560L1082.54 560L0 123.28999999999995z' fill='rgba(0%2c 0%2c 0%2c .025)'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1844'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3clinearGradient x1='50%25' y1='100%25' x2='50%25' y2='0%25' gradientUnits='userSpaceOnUse' id='SvgjsLinearGradient1845'%3e%3cstop stop-color='rgba(27%2c 26%2c 52%2c 1)' offset='0.09'%3e%3c/stop%3e%3cstop stop-color='rgba(27%2c 26%2c 52%2c 1)' offset='0.09'%3e%3c/stop%3e%3cstop stop-color='rgba(55%2c 48%2c 163%2c 1)' offset='1'%3e%3c/stop%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e");

    background-size: 100% 100%;
    background-position: center top;
    background-attachment: fixed;
}

</style>
